export default __webpack_public_path__ + "static/media/Kaspy-Phone1.4b261d75.webp";